var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoiceBadged = function SvgInvoiceBadged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    fill: "none",
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 22.5,
    r: 3.5,
    fill: props.accentFill
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "invoice-badged_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 22,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3.5H0v24h22v-24zm0 19a5 5 0 10-10 0 5 5 0 0010 0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#invoice-badged_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.5h-7c-.464 0-.91.177-1.237.493A1.65 1.65 0 004 7.182v13.454c0 .445.184.873.513 1.189.328.315.773.492 1.237.492h10.5c.464 0 .91-.177 1.237-.492.329-.316.513-.744.513-1.19v-10.09M12.75 5.5L18 10.545M12.75 5.5v5.045H18m-3.5 4.204h-7m7 3.364h-7m1.75-6.727H7.5",
    stroke: "#363840",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgInvoiceBadged;